<template>
  <app-layout class="create-organization-template">
    <Row type="flex" justify="center">
      <Col :span="24">
        <div style="padding:20px 15px">
          <Card v-if="steps == 'aggree'" shadow>
            <h3>Information</h3><br/>
            <p>The Alliance welcomes membership of individuals and organizations, both local and abroad, who have autonomous functions and structures and are willing to accept the principles and agenda of Sharpen Family for the Philippines as the basis of unity.</p>
            <br/>
            <Button type="primary" @click="steps = 'fill'" long>Agree</Button>
          </Card>
          <Card v-if="steps == 'fill' && fields" shadow>
            <!-- <p align="center" style="margin-bottom:10px">
              <Upload
                :show-upload-list="false"
                ref="upload"
                :on-success="handleAvatarSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="6144"
                :action="uploadEndPoint"
                name="photo[]"
                style="position:relative; margin:0px auto; display:table; align:center; line-height:unset;">
                <div style="position:relative;width:128px;height:128px;">
                  <img :src="identifyCoverImage(createData.avatar, imageUrl)"
                      style="border-radius: 20px;width:128px;height:128px;max-width:128px;border:1px solid #ddd;" width="128" height="128" alt="">
                  <Button icon="camera" type="text" style="margin:0px auto;">Set avatar</Button>
                </div>
            </Upload>
            </p> -->
            <div style="margin-bottom:10px">
              <span>
                <span style="font-weight: bold;font-size: 14px;">Organization Name</span><br/>
                <Input v-model="createData['display_name']"></Input>
              </span>
            </div>
            <div style="margin-bottom:10px">
              <span>
                <span style="font-weight: bold;font-size: 14px;">Brief Background of Organization</span><br/>
                <Input v-model="brief_background" type="textarea" :autosize="{minRows: 4,maxRows: 4}"></Input>
              </span>
            </div>
            <div style="margin-bottom:10px">
              <span>
                <span style="font-weight: bold;font-size: 14px;">Estimated number of members</span><br/>
                <RadioGroup v-model="estimate_members" vertical>
                  <Radio label="less than 100">less than 100</Radio>
                  <Radio label="100-1000">100-1000</Radio>
                  <Radio label="1001-5000">1001-5000</Radio>
                  <Radio label="5000+">5000+</Radio>
                </RadioGroup>
              </span>
            </div>
            <div style="margin-bottom:10px">
              <span>
                <span style="font-weight: bold;font-size: 14px;">Website</span><br/>
                <Input v-model="website"></Input>
              </span>
            </div>
            <div style="margin-bottom:10px">
              <span>
                <span style="font-weight: bold;font-size: 14px;">Facebook Page</span><br/>
                <Input v-model="fb_page"></Input>
              </span>
            </div>
            <!-- <div v-for="(field, i) in fields.fields" :key="i" style="margin-bottom:10px" v-if="field.slug !== 'youtube_channel' && field.slug !== 'fb_url' && field.slug !== 'street_address' && field.slug !== 'state'">
              <span v-if="field.type == 'string' && (field.slug !== 'contact_number' && field.slug !== 'province')">
                <span>{{field.label}}</span><br/>
                <Input v-if="field.slug==='background'" v-model="createData[field.slug]" type="textarea" row="6"></Input>
                <Input v-else v-model="createData[field.slug]"></Input>
              </span>
              <span v-if="field.type == 'string' && field.slug == 'province'">
                <span>Province</span><br/>
                <select v-model="createData['province']" class="ivu-select-selection custom-ui-select">
                  <option v-for="(item, k) in sortedProvinces" :key="k" @click="createData['province'] = item.name">{{ item.name }}</option>
                </select>
              </span>
              <span v-if="field.type == 'string' && field.slug == 'contact_number'">
                <span>{{field.label}}</span><br/>
                <tel-input-lg v-model="mobile" @onTelInput="onTelInput" ref="telInput"></tel-input-lg>
              </span>
              <span v-else-if="field.type == 'int'">
                <span>{{field.label}}</span><br/>
                <Input type="text" v-model="createData[field.slug]" style="width:100px"></Input>
              </span>
            </div> -->
            <br/>
            <!-- <Button type="success" @click="createBrand(createData)" long>Submit</Button> -->
            <Button :loading="this.submitLoading" type="primary" @click="submit()" long>Submit</Button>
          </Card>
          <Card v-if="steps == 'success'" shadow>
            <h3>Success</h3><br/>
            <p>We have successfully registered your organization</p>
            <br/><p>Please wait until <b>Sharpen Family</b> verified and approves your organization.</p>
            <br/>
            <router-link to="/home"><Button long >Done</Button></router-link>
          </Card>
        </div>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
  import Utils from '@/utils.js';
  import { TelInputLg } from '@/helpers/tel-input';
  import provinces from '@/helpers/ph-info/provinces.json'
  import {mapGetters} from 'vuex'

  export default {
    name: 'CreateOrganization',
    computed: {
      ...mapGetters("user",["brandInfo"]),
      sortedProvinces() {
        return this.provinces.sort(function (a, b) {
            return ('' + a.name).localeCompare(b.name);
        })
      },
      fields: {
        get() { return this.$store.state.org.fields[0]; }
      }
    },
    components: {
      TelInputLg
    },
    methods: {
      onTelInput(res) {
        this.createData['contact_number'] = (res.isValid) ? res.number: null;
      },
      handleAvatarSuccess(response, file) {
        this.imageUrl = process.env.VUE_APP_TEMP + file.response.uploaded[0];
        if('uploaded' in response && response.uploaded.length > 0)
            this.createData.avatar = response.uploaded[0]
      },
      identifyCoverImage: function(data, image) {
        if(image) return image;
        if(data != null) {
            if(Utils.validURL(data))
                return data;

            if(typeof data === 'string') {
                return process.env.TEMP + data;
            } else if(typeof data === 'object') {
                if('image' in data[0]) {
                    return data[0].image;
                } else if('url' in data[0]) {
                    if(Utils.validURL(data[0].url))
                        return data[0].url;
                    else
                        return process.env.TEMP + data[0].url;
                } else {
                    return data[0].large;
                }
            }
        } else {
            return 'https://via.placeholder.com/250/000000';
        }
        return data;
      },
      createBrand(data) {
        var avatar = _.clone(data.avatar);
        if (data.display_name)
          this.$store.dispatch('org/createdBrand', {data, avatar}).then( res => {
            this.createData = {
              group_type: "alliance",
              user_type: "group",
              email: Utils.uuidGenerator() + '@myndconsulting.com',
              username: Utils.uuidGenerator() + '@myndconsulting.com',
              password: Utils.uuidGenerator(),
              display_name: null,
              city: null,
              province: null,
              zip_code: null,
              contact_number: null,
              background: null
            },
            this.imageUrl= '';
            this.dialogCreateVisible= false
            this.steps = 'success';
          }) ;
        else
          toastr.warning('Please add organization name')
      },
      submit(){
        this.submitLoading = true

        this.form.recurrence = [Utils.setRrulePostDate(new Date())];
        this.form.data_type = "content";
        this.form.type = "organization_request";
        this.form.title = "Organization Request";
        this.form.is_published = 1
        this.form.data = {}
        this.form.data.brief_background = this.brief_background;
        this.form.data.estimate_members = this.estimate_members;
        this.form.data.fb_page = this.fb_page;
        this.form.data.website = this.website;
        this.form.data.organization_name = this.createData.display_name;
        
        this.form.show_dashboard = false
        if(!this.form.data.organization_name){
          this.$Message({
            closable: true,
            durationInSec:10,
            title: { content:'Required' },
            icon: 'alert',
            message: { content: 'Please add organization name' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> console.log('Organization Name Error')
              }
            ]
          });
          this.submitLoading = false
          return;
        }
        this.$store.dispatch("feed/postCareplanUpdate", {
            id: this.brandInfo.brand_default_groups.report_concern,
            data: this.form
          })
          .then(res => {
            this.steps = 'success';
            this.submitLoading = false
          },error =>{
            this.submitLoading = false
          });
      }
    },
    data() {
      return {
        uploadEndPoint: process.env.VUE_APP_API + 'uploadphoto',
        imageUrl: '',
        provinces,
        mobile: null,
        createData: {
          group_type: "alliance",
          user_type: "group",
          email: Utils.uuidGenerator() + '@myndconsulting.com',
          username: Utils.uuidGenerator() + '@myndconsulting.com',
          password: Utils.uuidGenerator(),
          display_name: null,
          city: null,
          province: null,
          developed_by: '1',
          zip_code: null,
          contact_number: null,
          background: null
        },
        steps: 'aggree',
        brief_background: '',
        estimate_members: 'less than 100',
        fb_page: '',
        website: '',
        submitLoading: false,
        form: Cons[0].ACTIVITY,
      }
    },
    mounted() {
      this.$store.dispatch('org/getOrganizationFields');
    }
  }
</script>
